/* eslint-disable */
/**
 * @author Leonel Martinez
 * @description `powerboxService` that call's Elasticsearch services
 * @exports powerboxService
 */
import { API } from "@/services";
import { http } from "@/utils";

export const powerboxService = {
  searchVehicles: (value, maxSize) => 
    http.get(`${API.POWERBOX.VEHICLES}${value}&maxSize=${maxSize}`).catch(e => e.response),
  searchP2VVehicles,
  searchParts: (value, maxSize) => 
     http.get(`${API.POWERBOX.PARTS}${value.toLowerCase()}&maxSize=${maxSize}`).catch(e => e.response),
  multisearch,
};

/**
 * @description Calls the Elasticsearch service to get vehicles that matches with the request
 * @param {string} request
 * @returns {Array} Possible vehicle list that matches the request
 */
// function searchVehicles(request) {
//   return http
//     .get(API.POWERBOX.VEHICLES + request)
//     .catch(e => e.response);
// }

function searchP2VVehicles(request) {
  return http
    .get(API.POWERBOX.P2V + request)
    .then(vehicles => Promise.resolve(vehicles.data))
    .catch(error => Promise.reject(error.response.data));
}

/**
 * @description Calls the Elasticsearch service to get vehicles that matches with the request
 * @param {string} request
 * @returns {Array} Possible vehicle list that matches the request
 */
function searchParts(request) {
  return http
    .get(API.POWERBOX.PARTS + request.toLowerCase())
    .catch(e => e.response);
}

/**
 * @async
 * @description Calls the Elasticsearch service to get vehicles and parts that matches with the request
 * @param {string} request
 * @returns {object} Mix of vehicles and parts returned back from Elasticsearch
 */
async function multisearch(request) {
  const vehicles = await http.get(API.POWERBOX.VEHICLES + request);
  const parts = await http.get(API.POWERBOX.PARTS + request);
  return {
    vehicles: vehicles.data,
    parts: parts.data
  };
}
